/**
 * provides a method to ask for the browser zoom level status and
 * a listener where you can register a function to get informed for zoom change events
 */
var ZoomDetector = /** @class */ (function () {
    function ZoomDetector() {
        this.baseLevel = 1.0;
        this.listeners = [];
        this.mediaQuery = 'screen and (-webkit-min-device-pixel-ratio: 2),' +
            'screen and ( min-device-pixel-ratio: 2),' +
            'screen and ( -webkit-min-resolution: 192dpi),' +
            'screen and ( min-resolution: 192dpi),' +
            'screen and ( -webkit-min-resolution: 2dppx),' +
            'screen and ( min-resolution: 2dppx)';
        if (window.matchMedia) {
            if (window.matchMedia(this.mediaQuery).matches) {
                // for retina-alike displays, use a higher base ratio for calculation
                this.baseLevel = 2.0;
            }
        }
        this.prevRatio = window.devicePixelRatio || this.baseLevel;
    }
    /**
     * register on zoom change events
     * @param fc
     */
    ZoomDetector.prototype.onZoom = function (fc) {
        var _this = this;
        this.listeners.push(fc);
        // first listerner activates the zoom polling
        if (this.listeners.length === 1) {
            this.prevRatio = this.zoomData.ratio;
            setInterval(function () {
                var zoomData = _this.zoomData;
                if (_this.prevRatio !== zoomData.ratio) {
                    _this.listeners.forEach(function (fc) { return fc(zoomData); });
                }
                _this.prevRatio = zoomData.ratio;
            }, 2000);
        }
    };
    Object.defineProperty(ZoomDetector.prototype, "zoomData", {
        get: function () {
            var ratio = parseFloat((window.devicePixelRatio || this.baseLevel).toFixed(2));
            return {
                baseRatio: this.baseLevel,
                ratio: ratio,
                width: window.innerWidth || 0,
                height: window.innerHeight || 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    return ZoomDetector;
}());
export default ZoomDetector;
//# sourceMappingURL=ZoomDetector.js.map